var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cancle-modal",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          _vm.handleClose(false)
        },
        mousedown: function ($event) {
          _vm.handleClose(false)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "main-c",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
            },
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("是否要取消投票")]),
          _vm._v(" "),
          _c("div", { staticClass: "btn-c" }, [
            _c(
              "div",
              {
                staticClass: "btn-1",
                on: {
                  click: function ($event) {
                    _vm.handleClose(false)
                  },
                },
              },
              [_vm._v("否")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn-2",
                style: _vm.getBtnStyle(),
                on: {
                  click: function ($event) {
                    _vm.handleClose(true)
                  },
                },
              },
              [_vm._v("是")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }